<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="input-container flex-center-h" on:click={handleClick}>
      {#if isEditing}
            <div class="editing flex">
                  <div class="input-addon flex">
                        <!-- Condicional para el tipo moneda, mostramos el símbolo $ -->
                        {#if tipo === "moneda"}
                              <div class="centrador-dolar-addon flex flex-center-h flex-center-v">
                                    <span class="addon">$</span>
                              </div>
                        {/if}
                        <input
                              bind:value
                              type="text"
                              class="input-excel"
                              on:blur={handleBlur}
                              on:keypress={handleKeyUp}
                              style="width: {w}"
                              autofocus
                        />
                  </div>
                  <div class="centrador-check-addon flex-center-h flex-center-v">
                        <span class="check-icon" on:click={handleSave}>✔️</span>
                  </div>
            </div>
      {:else}
            <p class=" col-12">
                  {#if tipo === "moneda"}
                        $
                  {/if}
                  {value}
            </p>
      {/if}
</div>

<script>
      import { createEventDispatcher } from "svelte";
      import About from "../../pages/About.svelte";

      export let value = ""; // Valor del input (texto por defecto)
      export let tipo = "text";
      export let w = "auto";
      //   export let tipo = "text"; // Tipo del input: 'text', 'number', 'email', etc.

      let isEditing = false; // Indica si el componente está en modo de edición
      const dispatch = createEventDispatcher(); // Para emitir el evento de cambio de valor

      function handleClick() {
            isEditing = true;
      }

      function handleSave() {
            isEditing = false;
            dispatch("save", value); // Emite el valor actualizado
      }

      function handleBlur() {
            isEditing = false;
            dispatch("save", value); // Emite el valor actualizado cuando el input pierde el foco
      }

      function handleKeyUp(event) {
            if (event.key === "Enter") {
                  handleSave();
            }
      }
</script>

<style>
      .editing {
            border-radius: 20px;
            overflow: hidden;
      }
      .input-excel {
            width: 100px;
      }
      .input-container {
            display: flex;
            align-items: center;
            cursor: pointer;
      }

      .input-container input {
            border: 1px solid #ccc;
            padding: 5px;
            font-size: 16px;
            width: 100%;
      }

      .input-container p {
            margin: 0;
            font-size: 16px;
            cursor: pointer;
      }

      .check-icon {
            margin-left: 10px;
            cursor: pointer;
            padding-right: 8px;
      }
      .addon {
            padding-right: 5px;
            font-size: 16px;
            font-weight: bold;
            padding: 8px;
      }
      .centrador-check-addon,
      .centrador-dolar-addon {
            background-color: #e9ecef;
      }
</style>
